// CSRF Token Management for better compatibility
document.addEventListener('DOMContentLoaded', function() {
  // Ensure CSRF token is available globally
  var csrfToken = document.querySelector('meta[name="csrf-token"]');
  if (csrfToken) {
    window.csrfToken = csrfToken.getAttribute('content');
  }
  
  // Add CSRF token to all AJAX requests
  if (window.jQuery) {
    jQuery.ajaxSetup({
      beforeSend: function(xhr, settings) {
        if (!/^(GET|HEAD|OPTIONS|TRACE)$/i.test(settings.type) && !this.crossDomain) {
          xhr.setRequestHeader("X-CSRF-Token", window.csrfToken);
        }
      }
    });
  }
  
  // Debug function to check CSRF token (remove in production)
  window.debugCSRF = function() {
    console.log('CSRF Token:', window.csrfToken);
    console.log('Meta tag:', document.querySelector('meta[name="csrf-token"]'));
    console.log('Form tokens:', document.querySelectorAll('input[name="authenticity_token"]'));
  };
});

// Handle Turbolinks page loads
document.addEventListener('turbolinks:load', function() {
  // Refresh CSRF token on page changes
  var csrfToken = document.querySelector('meta[name="csrf-token"]');
  if (csrfToken) {
    window.csrfToken = csrfToken.getAttribute('content');
  }
});